var _rect, _text, _path, _g, _path2, _path3, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg106(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uC5F0\uC18D\uBC88\uD638") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#fff8e6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 82,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 36,
    fontWeight: 900,
    fill: "#172033"
  }, "\uBD99\uC5B4 \uC788\uB294 \uC22B\uC790\uB3C4 \uC790\uC5F0\uC2A4\uB7EC\uC6B4 \uC870\uD569")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 225h440",
    stroke: "#0f766e",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeDasharray: "18 22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 42,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 225,
    r: 68,
    fill: "#ffd666",
    stroke: "#fff",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 240
  }, "12"), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 225,
    r: 68,
    fill: "#b9e6dc",
    stroke: "#fff",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 240
  }, "13"), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 225,
    r: 68,
    fill: "#d9ccff",
    stroke: "#fff",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 240
  }, "27"), /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 225,
    r: 68,
    fill: "#ffd6db",
    stroke: "#fff",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 240
  }, "28"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230 335h200",
    stroke: "#172033",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m410 315 25 20-25 20",
    fill: "none",
    stroke: "#172033",
    strokeWidth: 7
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 345,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 27,
    fontWeight: 800,
    fill: "#0f766e"
  }, "\uC5F0\uC18D \uD55C \uC30D\uC529")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg106);
export default __webpack_public_path__ + "static/media/106-연속번호.4b2cfb8ba49f6d933b5267dc75d7527a.svg";
export { ForwardRef as ReactComponent };